// extracted by mini-css-extract-plugin
export default {"wixIcon":"Igx8Uu"};